import _ from 'lodash'
import { ResponciveModule } from '../../Utils/responsiveModule'
import { convertParallaxImage } from '../../widget/api/utils'

// конвертируются параметры из виджета для эдитора
export const convertStyle = (captionStyle, widgetWidth, widgetHeight) => {
    let convertedStyle = _.cloneDeep(captionStyle)
    const diff = getDiff(widgetWidth, widgetHeight)
    convertedStyle.fontSize /= diff
    // convertedStyle.lineHeight /= diff
    if (convertedStyle.borderWidth >= 0.5 && convertedStyle.borderWidth / diff < 1) {
        convertedStyle.borderWidth = 1
    } else {
        convertedStyle.borderWidth /= diff
    }
    convertedStyle.padding /= diff

    // конвертирую параметры тени
    // convertedStyle.shadow.distance /= diff
    // convertedStyle.shadow.blur /= diff
    // convertedStyle.shadow.size /= diff
    // convertedStyle.shadow.x /= diff
    // convertedStyle.shadow.y /= diff

    if (convertedStyle.iconSettings) {
        convertedStyle.iconSettings.size /= diff
        convertedStyle.iconSettings.margin /= diff
    }

    if (convertedStyle.textStroke) {
        convertedStyle.textStroke.size /= diff
    }
    if (convertedStyle.shape === undefined || convertedStyle.shape === 'rectangle') {
        if (typeof convertedStyle.borderRadius === 'number') {
            convertedStyle.borderRadius /= diff
            // } else{
        } else if (convertedStyle.borderRadius) {
            convertedStyle.borderRadius.leftTop /= diff;
            convertedStyle.borderRadius.rightTop /= diff;
            convertedStyle.borderRadius.leftBottom /= diff;
            convertedStyle.borderRadius.rightBottom /= diff;

        } else {
            if (convertedStyle.type === 'shape' || convertedStyle.type === 'button') {
                convertedStyle.borderRadius = { leftTop: 0, rightTop: 0, leftBottom: 0, rightBottom: 0 }
            } else {
                convertedStyle.borderRadius = 0
            }
        }
    }
    return convertedStyle
}

export function convertMobileUmitableFields(caption, diffW, diffH, maxDiff) {

    if (caption.type === 'text') {
        const mobileFontSize = caption.mobileFontSize || caption.fontSize / maxDiff
        caption.shadow = convertFontShadowToMobile(caption.shadow, caption.fontSize, mobileFontSize)
    } else {
        caption.shadow.x = Math.round(caption.shadow.x / maxDiff);
        caption.shadow.y = Math.round(caption.shadow.y / maxDiff);
        caption.shadow.blur = Math.round(caption.shadow.blur / maxDiff)
        caption.shadow.size = Math.round(caption.shadow.size / maxDiff)
        // caption.shadow.x /= diffW;
        // caption.shadow.y /= diffH;
        // caption.shadow.blur /= maxDiff
        // caption.shadow.size /= maxDiff
        if (caption.type === 'button') {
            const mobileFontSize = caption.mobileFontSize || caption.fontSize / maxDiff
            caption.textShadow = convertFontShadowToMobile(caption.textShadow, caption.fontSize, mobileFontSize)
        }
    }

    // caption.distance /= maxDiff


    // caption.mobileBorderWidth = caption.borderWidth / maxDiff
    // if(typeof caption.borderRadius === 'number'){
    //     caption.mobileBorderRadius = caption.borderRadius / maxDiff
    // }else{
    //     caption.mobileBorderRadius.leftTop = caption.borderRadius.leftTop / maxDiff;
    //     caption.mobileBorderRadius.rightTop = caption.borderRadius.rightTop / maxDiff;
    //     caption.mobileBorderRadius.leftBottom = caption.borderRadius.leftBottom / maxDiff;
    //     caption.mobileBorderRadius.rightBottom = caption.borderRadius.rightBottom / maxDiff;

    // }

    return caption;
}

// адаптация тени текста для мобильного вида в зависимости от размера шрифта
// (параметра мобильной тени нет, поэтому адаптируем десктопную при каждом рендере)
function convertFontShadowToMobile(shadow, desktopFontSize, mobileFontSoze) {
    // если свойства тени нет, например тень текста у кнопки была не всегда
    if (!shadow) {
        shadow = { angle: 135, distance: 4, x: 3, y: 3, blur: 5, size: 1, color: 'rgba(0,0,0,0.5)' }
    }
    const fontSizeProp = desktopFontSize / mobileFontSoze
    return {
        x: Math.round(shadow.x / fontSizeProp),
        y: Math.round(shadow.y / fontSizeProp),
        blur: shadow.blur / fontSizeProp,
        color: shadow.color
    }
}

function convertPositions(caption, diff) {
    caption.position.x = Math.round(caption.position.x / diff)
    caption.position.y = Math.round(caption.position.y / diff)
    if (caption.boxId != '') {
        caption.position.relativeX = Math.round(caption.position.relativeX / diff)
        caption.position.relativeY = Math.round(caption.position.relativeY / diff)
    }

    return caption
}

function convertShadow(shadow, diff) {
    // const regex = /(\d+(\.\d+)?\))/;
    // const opacityShadow = parseFloat(shadow.color.match(regex)[0])

    // shadow.color = shadow.color.replace(opacityShadow, `${opacityShadow / diff})`)
    shadow.blur /= diff
    shadow.size /= diff
    shadow.distance /= diff
    shadow.x /= diff
    shadow.y /= diff

    return shadow
}

export function convertDimension(caption, diff) {
    if (caption.width != undefined && caption.height != undefined) {
        caption.width /= diff
        caption.height /= diff
        // округляем до верхнего значения, иначе текст в капчах переносится на вторую строку
        // при инициализации слайда
        // убрал округление, т.к. размеры капч заметно изменяются
        // caption.width = Math.round(caption.width / diff)
        // caption.height = Math.round(caption.height / diff)

    }
    return caption
}

// нигде не используется (планировалось использовать при создании капчи)
// export function convertDimensionTextCaption(caption, diff) {
//     if (caption.width != undefined && caption.height != undefined) {
//         caption.width /= diff
//         caption.height /= diff
//         // при добавлении капи в рабочее пространство нужно пересчитывать и размер шрифта,
//         // иначе капча может быть больше своих положенных размеров
//         // при маленьких размерах виджета размер текста получается огромным
//         if (caption.fontSize != undefined) caption.fontSize /= diff
//         if (caption.lineHeight != undefined) caption.lineHeight /= diff

//     }
//     return caption
// }

function convertBoxPointPosition(pointsArray, diff) {
    pointsArray.map((point) => {
        point.x /= diff
        point.y /= diff
    })

    return pointsArray
}

// запускаем при открывании окна редактора слайда
export function convertSettings(settings, widgetWidth, widgetHeight) {
    const diff = getDiff(widgetWidth, widgetHeight);
    const width = widgetWidth / diff;
    const height = widgetHeight / diff;
    let convertedSettings = _.cloneDeep(settings)
    convertedSettings.backgroundShadow = convertShadow(convertedSettings.backgroundShadow, diff)
    // console.log('convertedSettings',convertedSettings)
    convertedSettings.captions.map((caption, index) => {
        caption = convertPositions(caption, diff);
        caption = convertDimension(caption, diff)
        caption.shadow = convertShadow(caption.shadow, diff)

        // на случай ошибки, в результате которой радиус === null
        // пока не понятно как это происходит
        if (caption.borderRadius === null || caption.borderRadius === undefined || caption.borderRadius === NaN) {
            if (caption.type === 'shape' || caption.type === 'box') {
                caption.borderRadius = { leftTop: 0, rightTop: 0, leftBottom: 0, rightBottom: 0 }
            } else {
                caption.borderRadius = 0
            }
        }

        // if (caption.type === 'box') {
        //     caption.pointsArray = convertBoxPointPosition(caption.pointsArray, diff)
        // }
    })

    convertedSettings.widgetData.height = height;
    convertedSettings.widgetData.width = width;
    return convertedSettings
}


export function converCroppingAreaStyle(widgetData) {
    const widgetWidth = widgetData.width;
    const widgetHeight = widgetData.height
    const diff = getDiff(widgetWidth, widgetHeight)
    // console.log('diff',diff);
    // let convertedCroppingAreaStyle = {
    //     width: widgetWidth / diff,
    //     height: widgetHeight / diff,
    // }
    widgetData.width /= diff
    widgetData.height /= diff
    // widgetData.offsetX /= diff
    // widgetData.offsetY /= diff

    return widgetData
}


export function convertParallaxImageStyle(uncovertedStyle, widgetWidth, widgetHeight) {
    // console.log('CALL convertParallaxImageStyle');
    const diff = getDiff(widgetWidth, widgetHeight);
    // console.log('diff',diff,'widgetWidth, widgetHeight',widgetWidth, widgetHeight);

    uncovertedStyle.offsetX /= diff
    uncovertedStyle.offsetY /= diff

    return uncovertedStyle
}
// export function convertParallaxImageStyle(uncovertedStyle, widgetWidth, widgetHeight) {
//     // console.log('CALL convertParallaxImageStyle');
//     const diff = getDiff(widgetWidth, widgetHeight);
//     // console.log('diff',diff);

//     uncovertedStyle.offsetX /= diff
//     uncovertedStyle.offsetY /= diff

//     return uncovertedStyle
// }


export function getDiff(widgetWidth, widgetHeight) {
    const maxWidth = 970;
    const maxHeight = 450;
    // console.log('widgetHeight',widgetHeight);
    const diffW = widgetWidth / maxWidth;
    const diffH = widgetHeight / maxHeight;
    // let diff = 1;


    // // рассчитываю пропорции виджета и окна редактора
    // const widgetRatio = widgetHeight / widgetWidth
    // const defaultRatio = maxHeight / maxWidth
    // if (widgetRatio > defaultRatio) {
    //     // если виджет выше допустимого окна
    //     diff = widgetHeight / maxHeight
    //     // console.log('diff виджет выше допустимого окна',diff);
    // } else {
    //     // если виджет шире допустимого окна
    //     diff = widgetWidth / maxWidth
    //     // console.log('diff виджет шире допустимого окна',diff);
    // }
    // return diff


    // if (widgetWidth > maxWidth && widgetHeight > maxHeight) {

    //     if (widgetWidth > widgetHeight) {
    //         diff = diffW
    //     } else {
    //         diff = diffH
    //     }


    // } else if (widgetWidth > maxWidth && widgetHeight <= maxHeight) {
    //     diff = diffW
    // } else if (widgetWidth <= maxWidth && widgetHeight > maxHeight) {
    //     diff = diffH
    // }

    // if(diffW >= diffH){
    // return diffW;
    // }else{
    // return diffH;
    // }
    const containerRatio = maxHeight / maxWidth
    const widgetRatio = widgetHeight / widgetWidth
    // console.log('containerRatio',containerRatio,'widgetRatio',widgetRatio);
    // console.log('diffW',diffW,'diffH',diffH);
    if (containerRatio > widgetRatio) {
        // виджет широкий
        return diffW;
    } else {
        // виджет высокий
        return diffH;
    }

    // return diff


}


export function getDiffToMobileConvert(width, height, mobileWidth, mobileHeight) {

    // let maxDiff = 1;
    // const widgetRatio = mobileHeight / mobileWidth
    // const defaultRatio = height / width
    // if (widgetRatio > defaultRatio) {
    //     // если виджет выше допустимого окна
    //     maxDiff =  height / mobileHeight
    //     // maxDiff = mobileHeight / height
    //     console.log('diff виджет выше допустимого окна',maxDiff);
    // } else {
    //     // если виджет шире допустимого окна
    //     maxDiff =  width / mobileWidth
    //     // maxDiff = mobileWidth / width
    //     console.log('diff виджет шире допустимого окна',maxDiff);
    // }
    // // return maxDiff



    // console.log('getDiffToMobileConvert width',width,'height',height);
    // console.log('getDiffToMobileConvert mobileWidth',mobileWidth,'mobileHeight',mobileHeight);
    const mobileDiffW = width / mobileWidth;
    const mobileDiffH = height / mobileHeight;
    // console.log('getDiffToMobileConvert mobileDiffW',mobileDiffW,'mobileDiffH',mobileDiffH);

    // return {mobileDiffW, mobileDiffH, maxDiff}
    return { mobileDiffW, mobileDiffH }
}

export function convertParallaxPositionFromWidgetToEditor(parallaxImage, settingsReducer, ssData) {
    const editedWidth = settingsReducer.widgetDimensions.editedWidth
    const editedHeight = settingsReducer.widgetDimensions.editedHeight
    const editedWidthMobile = settingsReducer.widgetDimensions.editedWidthMobile
    const editedHeightMobile = settingsReducer.widgetDimensions.editedHeightMobile
    const realWidth = ssData.width;
    const realHeight = ssData.height;
    const realWidthMobile = ssData.mobileWidth;
    const realHeightMobile = ssData.mobileHeight;


    // сначала конвертируем параметры для десктопа в то, как выглядит сейчас параллакс с учётом изменения размеров виджета
    const parallaxImageDesktop = convertParallaxImage(parallaxImage, editedWidth, editedHeight, realWidth, realHeight, false)
    // потом этот же объект прогоняем через мобильную конвертацию
    const parallaxImageDesktopAndMobile = convertParallaxImage(parallaxImageDesktop, editedWidthMobile, editedHeightMobile, realWidthMobile, realHeightMobile, true)

    return parallaxImageDesktopAndMobile
}

// конвертация из виджета в редактор, учитывая адаптацию капч при изменении размеров виджета
export function convertCaptionsFromWidgetToEditor(slide) {
    let captions = _.cloneDeep(slide.captions)
    if (slide.editedWidth) {

        let rm = new ResponciveModule(
            //desktop
            slide.widgetData.originalWidth,
            slide.widgetData.originalHeight,
            slide.editedWidth,
            slide.editedHeight,

            //mobile
            slide.widgetData.mobileWidth,
            slide.widgetData.mobileHeight,
            slide.editedWidthMobile,
            slide.editedHeightMobile,
            false
        );
        // конвертация десктопных параметров
        captions = rm.adaptCaptions(captions);
        rm.isMobile = true
        // конвертация мобильных параметров
        captions = rm.adaptCaptions(captions);
        // уничтожаю класс, иначе реакт ругается
        rm = null
        return captions
    }
    return captions
}

